import { render, staticRenderFns } from "./InsPage.vue?vue&type=template&id=ad465a46&scoped=true&"
import script from "./InsPage.vue?vue&type=script&lang=ts&"
export * from "./InsPage.vue?vue&type=script&lang=ts&"
import style0 from "./InsPage.vue?vue&type=style&index=0&id=ad465a46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad465a46",
  null
  
)

export default component.exports